
import { supabaseWorker } from '@/integrations/supabase/workerClient';

export interface PodpislonSignatureRequest {
  orderId: string;
  phoneNumber: string;
  document: File | Blob;
  clientName: string;
  documentType: 'contract' | 'act' | 'invoice';
}

export interface PodpislonSignatureStatus {
  id: string;
  status: 'pending' | 'signed' | 'rejected' | 'expired';
  signedDocument?: string;
  signedAt?: string;
  rejectedAt?: string;
  expiresAt: string;
}

export class PodpislonService {
  private static instance: PodpislonService;
  private readonly baseUrl = 'https://api.podpislon.ru/v1';

  public static getInstance(): PodpislonService {
    if (!PodpislonService.instance) {
      PodpislonService.instance = new PodpislonService();
    }
    return PodpislonService.instance;
  }

  async sendForSignature({
    orderId,
    phoneNumber,
    document,
    clientName,
    documentType
  }: PodpislonSignatureRequest): Promise<{ signatureId: string }> {
    try {
      console.log('[PodpislonService] Sending document for signature via podpislon.ru:', { 
        orderId, phoneNumber, documentType 
      });

      // Создаем FormData для отправки файла
      const formData = new FormData();
      formData.append('document', document);
      formData.append('phone', phoneNumber);
      formData.append('client_name', clientName);
      formData.append('document_type', documentType);
      formData.append('order_id', orderId);
      formData.append('callback_url', `${window.location.origin}/api/podpislon/callback`);

      // Отправляем через Supabase Edge Function для безопасности
      const { data, error } = await supabaseWorker.functions.invoke('podpislon-signature-request', {
        body: formData
      });

      if (error) {
        console.error('[PodpislonService] Error:', error);
        throw error;
      }

      console.log('[PodpislonService] Signature request sent successfully:', data);
      return { signatureId: data.signature_id };
    } catch (error) {
      console.error('[PodpislonService] Failed to send for signature:', error);
      throw error;
    }
  }

  async getSignatureStatus(signatureId: string): Promise<PodpislonSignatureStatus> {
    try {
      console.log('[PodpislonService] Getting signature status:', signatureId);

      const { data, error } = await supabaseWorker.functions.invoke('podpislon-check-status', {
        body: { signatureId }
      }); 
      return data as PodpislonSignatureStatus;
    } catch (error) {
      console.error('[PodpislonService] Failed to get signature status:', error);
      throw error;
    }
  }

  async cancelSignature(signatureId: string): Promise<boolean> {
    try {
      console.log('[PodpislonService] Cancelling signature:', signatureId);

      const { data, error } = await supabaseWorker.functions.invoke('podpislon-signature-cancel', {
        body: { signature_id: signatureId }
      });

      if (error) {
        console.error('[PodpislonService] Error cancelling:', error);
        throw error;
      }

      return data.success;
    } catch (error) {
      console.error('[PodpislonService] Failed to cancel signature:', error);
      throw error;
    }
  }
}

export const podpislonService = PodpislonService.getInstance();
